module.exports = __webpack_public_path__ + "media/application/images/svgs/log-in-cfa0d847169b1c771126cc1beda198ca.svg";